import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonGroup } from '@dixa/lib-shared-habla';
import { memo, useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { useAnalyticsState } from 'app/views/layout/views/analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';
export const ChartInstrumentGranularity = memo(function ChartInstrumentVisualization({ panel, granularities, onChangeGranularity, }) {
    const { dashboard } = useAnalyticsState();
    const handleChange = useCallback((value) => {
        onChangeGranularity === null || onChangeGranularity === void 0 ? void 0 : onChangeGranularity(value);
        analytics.analyticsChartGranularityChanged({
            granularity: value,
            panel: panel.title,
            dashboard: dashboard.title,
        });
    }, [dashboard.title, onChangeGranularity, panel.title]);
    return (_jsx(ButtonGroup, Object.assign({ variant: "secondary" }, { children: granularities.map(({ value, selected }) => (_jsx(Button, Object.assign({ onClick: selected ? undefined : () => handleChange(value), active: selected }, { children: value }), value))) })));
});
